import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

interface AlertsRibbonProps {
  onOpen: () => void;
}

export function AlertsRibbon({ onOpen }: AlertsRibbonProps) {
  const { data } = useQuery({
    queryKey: ["alerts-status"],
    queryFn: api.alerts.status,
    refetchInterval: 10_000,
  });

  const alerts = data?.alerts ?? [];
  const breached = alerts.filter((a) => a.breached);
  const hasAlerts = alerts.length > 0;

  if (!hasAlerts) return null;

  return (
    <button
      type="button"
      onClick={onOpen}
      className="flex items-center gap-2 max-md:gap-1.5"
      title={
        breached.length > 0
          ? `${breached.length} active warning${breached.length > 1 ? "s" : ""}`
          : "All monitored parameters within limits"
      }
    >
      <span className="text-[10px] uppercase tracking-[0.18em] text-dim max-md:hidden">
        Warnings
      </span>
      {breached.length > 0 ? (
        <span className="flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-full bg-wb animate-pulseLive" />
          <span className="text-xs font-medium tracking-wider uppercase text-wb">
            {breached.length}
          </span>
        </span>
      ) : (
        <span className="flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-full bg-ok" />
          <span className="text-xs font-medium tracking-wider uppercase text-ok max-md:hidden">
            OK
          </span>
        </span>
      )}
    </button>
  );
}
